<template>
  <section>
    <h3
      v-if="calculating"
      style="margin: 3rem auto; width: 280px; font-size: 3rem; font-weight: 600;"
    >
      網頁導向中...
    </h3>
    <div v-else style="margin: 15% auto; width: 980px;">
      <div style="font-size: 3rem; font-weight: 600; text-align: center;">
        <a
          v-if="url"
          :href="url"
          target="_blank"
          rel="noopener"
          @click="onLinkClick"
        >
          開啟後台 2.0 訂單
        </a>
        <a v-else @click="redirectToAdmin2">重新導向</a>
      </div>
    </div>
    <b-loading :active="calculating" :is-full-page="true" :can-cancel="false" />
  </section>
</template>

<script>
import notifyService from '@/services/notifyService'
import { openAdmin2 } from '@/utils/admin2'

export default {
  name: 'Orders',
  data() {
    return {
      calculating: false,
      url: ''
    }
  },
  mounted() {
    this.redirectToAdmin2()
  },
  methods: {
    onLinkClick() {
      // token 只能用一次，點過就換回「重新導向」；延到下一個 task 才清，
      // 免得 Vue 先拿掉 href，瀏覽器就不導覽了
      setTimeout(() => {
        this.url = ''
      }, 0)
    },
    async redirectToAdmin2() {
      try {
        this.calculating = true

        // 進頁面時不是點擊觸發，分頁常被瀏覽器擋下；擋下時改顯示連結讓使用者點
        this.url = (await openAdmin2(this.axios, 'orders')) || ''
      } catch (e) {
        this.url = ''

        notifyService.fetch_error('jwt_token', e)
      } finally {
        this.calculating = false
      }
    }
  }
}
</script>
